import ListItem from "@mui/material/ListItem";
import Box from "@mui/material/Box";

interface CompactListItemProps {
  start?: boolean;
  end?: boolean;
  children?: React.ReactNode;
}

const CompactListItem: React.FC<CompactListItemProps> = ({
  start,
  end,
  children,
}) => {
  return (
    <ListItem disablePadding>
      <Box
        sx={{
          margin: 0,
          borderLeft: "1px solid #D0D1D3",
          borderBottom: "1px solid #D0D1D3",
          borderRight: "1px solid #D0D1D3",
          borderTop: start ? "1px solid #D0D1D3" : 0,
          borderTopLeftRadius: start ? "8px" : 0,
          borderTopRightRadius: start ? "8px" : 0,
          borderBottomLeftRadius: end ? "8px" : 0,
          borderBottomRightRadius: end ? "8px" : 0,
          width: "100%",
        }}
      >
        {children}
      </Box>
    </ListItem>
  );
};

export default CompactListItem;
